module.exports = __webpack_public_path__ + "static/media/expedia-card.d20aae19.png";